module.exports = __webpack_public_path__ + "img/root00.fb285cc2.png";